import type { TFunction } from 'i18next';

import { COIN_BACK_DATA_TEST_ID, COIN_BACK_TUTORIAL_DATA_TEST_ID } from '../../../features/coinbackTutorial/constants';
import type { CoinType } from '../../../stores/cointype/CoinTypeStore';
import { formatValueWithK } from '../../../utils/helpers';

export const formatCoinBackBalanceValue = (value: number, coinType: CoinType, t: TFunction) => {
  if (coinType === 'GC') {
    if (value < 100000) {
      if (Number.isInteger(value)) {
        return value.toLocaleString();
      } else {
        const valueFixed = value.toFixed(2);
        if (valueFixed.endsWith('00')) {
          return Number(value.toFixed(0)).toLocaleString();
        } else {
          return Number(valueFixed).toLocaleString();
        }
      }
    } else {
      const formattedWithK = formatValueWithK(value, t);
      return formattedWithK.toLocaleString();
    }
  } else {
    return Number(value.toFixed(2)).toLocaleString();
  }
};

export const getCoinBackDataTestId = (suffix: string, isTutorialOpen: boolean): string => {
  const baseTestId = isTutorialOpen ? COIN_BACK_TUTORIAL_DATA_TEST_ID : COIN_BACK_DATA_TEST_ID;
  return `${baseTestId}-${suffix}`;
};
